import axios from 'axios'
import apiurl from '../config/api'

export function getDevice() {
  return axios.get(apiurl.getDevice)
    .then(result => {

      return result.data.data
    })
}